import type { UsageProduct,
  UsageProductInput,
  UsageProductVariantInput,
  UsageProductVariant,
  NewUsageProduct } from '@weft/types';
import React from 'react';
import { UsageProductVariantHeaderEdit } from './UsageProductVariantHeaderEdit';
import { UsageProductVariantHeaderView } from './UsageProductVariantHeaderView';

type UsageProductVariantHeaderProps = {
  costEstimation?: number;
  className?: string;
  isEditing: boolean;
  product: UsageProduct | NewUsageProduct;
  productIndex: number,
  productVariant: UsageProductVariantInput | UsageProductVariant,
  productVariantIndex: number,
};

export const UsageProductVariantHeader:React.FC<UsageProductVariantHeaderProps> = ({
  product,
  productIndex,
  productVariant,
  productVariantIndex,
  costEstimation,
  className,
  isEditing,
}) => {
  return (
    <div className={className}>
      {isEditing ?
        <UsageProductVariantHeaderEdit {...{
          productIndex,
          product: product as UsageProductInput,
          productVariantIndex,
          productVariant: productVariant as UsageProductVariantInput,
        }}
        />
        : (
          <UsageProductVariantHeaderView
            name={product.variants[productVariantIndex].name}
            description={product.variants[productVariantIndex].description ?? undefined}
            costEstimation={costEstimation}
            price={product.basePrice}
          />)
          }
    </div>
  );
};